/**
 * TeacherDashboards — entry for /me/*. Mounts the teacher shell at the parent
 * route; the buckets render through <Outlet /> as child routes so the chrome
 * stays mounted across navigation.
 *
 * `/me` opens on My schedule. Most pages below are still reachable by address
 * only, until each is built and given a nav entry.
 *
 * The shell is the page header and nothing else — the logo, search, the
 * signed-in user, appearance and sign out all live in the app chrome around it.
 */
import { Navigate, Route, Routes } from 'react-router-dom';

import TeacherPrivateEventPage from '../../private-events/TeacherPrivateEventPage';
import CheckInModalRoute from '../workshops/detail/CheckInModalRoute';
import WorkshopDetailPage from '../workshops/WorkshopDetailPage';

import TeacherAvailability from './TeacherAvailability';
import TeacherMyRequests from './TeacherMyRequests';
import TeacherOpenShifts from './TeacherOpenShifts';
import TeacherOverview from './TeacherOverview';
import TeacherPay from './TeacherPay';
import TeacherResources from './TeacherResources';
import TeacherSchedule from './TeacherSchedule';
import { TeacherShell } from './TeacherShell';
import TeacherSupplies from './TeacherSupplies';
import TeacherWorkHistory from './TeacherWorkHistory';

export default function TeacherDashboards() {
  return (
    <Routes>
      <Route element={<TeacherShell />}>
        <Route index element={<Navigate to="schedule" replace />} />
        <Route path="schedule" element={<TeacherOverview />} />
        <Route path="region-schedule" element={<TeacherSchedule />} />
        <Route path="supplies" element={<TeacherSupplies />} />
        <Route path="resources" element={<TeacherResources />} />
        <Route path="availability" element={<TeacherAvailability />} />
        <Route path="shifts" element={<TeacherOpenShifts />} />
        <Route path="requests" element={<TeacherMyRequests />} />
        <Route path="history" element={<TeacherWorkHistory />} />
        <Route path="pay" element={<TeacherPay />} />
        <Route path="workshops/:workshopId" element={<WorkshopDetailPage />}>
          <Route path="checkin" element={<CheckInModalRoute />} />
        </Route>
        <Route path="private-events/:id" element={<TeacherPrivateEventPage />} />
        <Route path="*" element={<Navigate to="/me/schedule" replace />} />
      </Route>
    </Routes>
  );
}
